
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parking-coupons/[id]",
      function () {
        return require("private-next-pages/parking-coupons/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parking-coupons/[id]"])
      });
    }
  